import { ROUTE_CONSTANTS } from "./routeConstants";
import { INavigationActions, IRouter } from "./types";

let router: IRouter;

export const setRouter = (routerInstance: any) => {
  if (!routerInstance) {
    throw new Error(
      "Couldn't set router,routerInstance object is null or undefined"
    );
  }
  router = routerInstance;
};

function getURLFromRouteAndParams(route: string, params?: any) {
  let searchParams = "";
  const routeParts = route.split("?");
  const baseRoute = routeParts[0];
  const existingParams = routeParts[1]
    ? new URLSearchParams(routeParts[1])
    : new URLSearchParams();

  Object.keys(params || {}).forEach((key) =>
    existingParams.set(key, params[key])
  );

  searchParams = existingParams.toString();

  const queryJoin = searchParams.length > 0 ? "?" : "";
  return `${baseRoute}${queryJoin}${searchParams}`;
}

/* istanbul ignore next */
function forceRedirectOnWwwSubdomain(pathName: string) {
  if (typeof location === "undefined") return;
  const host = new URL(location.href).host;
  switch (host) {
    case "insurance.makemytrip.com":
      location.href = `https://www.makemytrip.com/insurance${pathName}`;
      break;
    case "insurance.goibibo.com":
      location.href = `https://www.goibibo.com/insurance${pathName}`;
      break;
    default:
      router.push(pathName);
  }
}

function forceRedirectOnInsuranceSubdomain(pathName: string) {
  if (typeof location === "undefined") return;
  const host = new URL(location.href).host;
  switch (host) {
    case "www.makemytrip.com":
      location.href = `https://insurance.makemytrip.com/insurance${pathName}`;
      break;
    case "www.goibibo.com":
      location.href = `https://insurance.goibibo.com/insurance${pathName}`;
      break;
    default:
      router.push(pathName);
  }
}

function injectInternalSourceInParams(params?: any) {
  if (typeof window === "undefined") {
    return params;
  }

  const updatedParams = { ...params };
  const urlParams = new URLSearchParams(window.location.search);
  const cmpFromUrl = urlParams.get("cmp");

  if (!updatedParams.internal_source) {
    const internalSource = sessionStorage.getItem("internal_source");
    const val = internalSource || cmpFromUrl;
    if (typeof val === "string" && val !== "") {
      updatedParams.internal_source = val;
    }
  }

  if (!updatedParams.cmp && cmpFromUrl) {
    updatedParams.cmp = cmpFromUrl;
  }

  return updatedParams;
}

export const navigationActions: INavigationActions = {
  navigateToLanding: (
    params?: any,
    shouldForceRedirectOnWwwSubdomain = true
  ) => {
    params = injectInternalSourceInParams(params);
    const pathName = getURLFromRouteAndParams(
      ROUTE_CONSTANTS.LANDING_PAGE,
      params
    );
    router.push(pathName);
  },
  navigateToListing: (params?: any) => {
    params = injectInternalSourceInParams(params);
    router.push(
      getURLFromRouteAndParams(ROUTE_CONSTANTS.LISTING_SCREEN, params)
    );
  },
  navigateToCommonLanding: (params?: any) => {
    params = injectInternalSourceInParams(params);
    router.push(
      getURLFromRouteAndParams(ROUTE_CONSTANTS.COMMON_LANDING, params)
    );
  },
  navigateToTravellerDetails: (params?: any) => {
    params = injectInternalSourceInParams(params);
    router.push(
      getURLFromRouteAndParams(ROUTE_CONSTANTS.TRAVELLER_DETAILS, params)
    );
  },
  navigateToAddPassport: (params?: any) => {
    params = injectInternalSourceInParams(params);
    router.push(getURLFromRouteAndParams(ROUTE_CONSTANTS.ADD_PASSPORT, params));
  },
  navigateToOrderConfirmed: (params?: any) => {
    params = injectInternalSourceInParams(params);
    router.push(
      getURLFromRouteAndParams(ROUTE_CONSTANTS.ORDER_CONFIRMED, params)
    );
  },
  navigateToOrderListing: (params?: any) => {
    params = injectInternalSourceInParams(params);
    router.push(
      getURLFromRouteAndParams(ROUTE_CONSTANTS.ORDER_LISTING, params)
    );
  },
  navigateToOrderDetails: (params?: any) => {
    params = injectInternalSourceInParams(params);
    router.push(
      getURLFromRouteAndParams(ROUTE_CONSTANTS.ORDER_DETAILS, params)
    );
  },
  navigateToDownloadPolicy: (params?: any) => {
    params = injectInternalSourceInParams(params);
    router.push(
      getURLFromRouteAndParams(ROUTE_CONSTANTS.DOWNLOAD_POLICY, params)
    );
  },
  goBack: ({ forceExit }: { forceExit?: boolean } = {}) => {
    if (forceExit) {
      window.history.go(-(window.history.length - 2));
    } else {
      router.back();
    }
  },
  navigateToPageByRouteName: (route: string, params?: any) => {
    params = injectInternalSourceInParams(params);

    router.push(getURLFromRouteAndParams(route, params));
  },
  navigateToRouteNameWithHostname: (route: string, params?: any) => {
    params = injectInternalSourceInParams(params);
    const hostname = window.location.hostname;
    const routeWithHostname = `${hostname}${getURLFromRouteAndParams(
      route,
      params
    )}`;
    location.href = `https://${routeWithHostname}`;
  },
};
